<a class="action" [attr.href]="href" [attr.target]="target"><ng-content></ng-content></a>
